module.exports = __webpack_public_path__ + "static/img/qytj5.ae6e1d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/qytj5.jpg
// module id = 3IIF
// module chunks = 171